import BaseAccordionElement, { html, defineElement, Events as AccordionEvents } from '@webtides/accordion-element';
import { Events } from '@webtides/lazy-src';

import style from './accordion-element.css';

class AccordionElement extends BaseAccordionElement {
    styles() {
        return [style];
    }

    connected() {
        super.connected();
        this.querySelectorAll('[cloak="true"]').forEach((slot) => slot.removeAttribute('cloak'));

        // fires resize event, if nested accordion is growing;
        const content = this.querySelector('[slot="content"]');
        const resizeObserver = new ResizeObserver(() => {
            if (this.open) {
                let height = content.offsetHeight;
                const style = getComputedStyle(content);
                height += parseInt(style.marginTop) + parseInt(style.marginBottom);
                this.$refs.content.style.height = height + 'px';
            }
        });
        resizeObserver.observe(content);
    }

    properties() {
        return {
            ...super.properties(),
            iconColorClass: '',
            titleCssClass: '',
        };
    }

    events() {
        return {
            '[data-toggle]': {
                click: () => {
                    this.toggle();
                    this.querySelectorAll('carousel-element').forEach((el) => el.requestUpdate());
                },
            },
            '[ref=content]': {
                [Events.IMG_LOAD]: () => {
                    if (this.open) this.expand();
                },
            },
            this: {
                [AccordionEvents.TOGGLE]: (event) => {
                    if (event.target !== this) event.stopPropagation();
                },
            },
        };
    }

    template() {
        return html`
            <div part="title-wrapper" class="${this.titleCssClass}" ref="header" data-toggle>
                ${this.iconsTemplate()}
                <slot name="header"></slot>
            </div>
            <div part="content-wrapper" class="content-wrapper" ref="content">
                <slot name="content"></slot>
            </div>
        `;
    }

    iconsTemplate() {
        return html`
            <div class="relative flex w-6 items-center ${this.iconColorClass} ">
                <svg-use part="open-icon" class="open-icon" name="icons-material-outline-plus"></svg-use>
                <svg-use part="close-icon" class="close-icon" name="icons-material-outline-minus"></svg-use>
            </div>
        `;
    }
}

export function define() {
    defineElement('accordion-element', AccordionElement);
}
